import { ValidatorFn, AbstractControl, Validators, ValidationErrors } from '@angular/forms';
import { Numbers } from 'src/app/utils/constants';

/**
 * @description Recuperar IBAN
 * @param letra letra
 * @returns returns
 */

export const getnumIBAN: (letra: string) => number = (letra: string): number => {
  const lsLetras = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const number10 = 10;
  return lsLetras.search(letra) + number10;
};
/**
 * @description Funcion para calcular el resto
 * @param iban iban
 * @returns returns
 */

export const modulo97: (iban: any) => string = (iban: any): string => {
  const parts = Math.ceil(iban.length / Numbers.number7);
  let remainer = '';
  for (let i = 1; i <= parts; i++) {
    remainer = String(parseFloat(remainer + iban.substr((i - Numbers.number1) * Numbers.number7,
    Numbers.number7)) % Numbers.number97);
  }

  return remainer;
};

/**
 * @description Validates if a control value exceeds a maximum length
 * @returns returns
 */
export const ibanValidator: () => ValidatorFn = (): ValidatorFn => {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    const valueField: string = control.value;
    let returnV: { ibanValidator: boolean} | ValidationErrors;
    let iban: string = valueField.toUpperCase();
    iban = iban.trim();
    iban = iban.replace(/\s/g, ''); // Y se quita los espacios en blanco dentro de la cadena
    let isbanaux: string;
    if (iban.length > 1) {
      // La longitud debe ser siempre de 24 caracteres
      if (iban.length !== Numbers.number24) {
        returnV = { ibanValidator: true };
      } else {
        // Se coge las primeras dos letras y se pasan a números
        const letra1: string = iban.substring(Numbers.number0, Numbers.number1);
        const letra2: string = iban.substring(Numbers.number1, Numbers.number2);
        const num1: number = getnumIBAN(letra1);
        const num2: number = getnumIBAN(letra2);
        // Se sustituye las letras por números.
        isbanaux = String(num1) + String(num2) + iban.substring(Numbers.number2);
        // Se mueve los 6 primeros caracteres al final de la cadena.
        isbanaux = isbanaux.substring(Numbers.number6) + isbanaux.substring(Numbers.number0, Numbers.number6);

        const errors: ValidationErrors = control.errors;
        let errorsA: ValidationErrors = null;
        let errorE = false;
        if (errors !== null) {
          delete errors.ibanValidator;
          errorE = Object.keys(errors).length === 0;
        }
        if (errorE === true) {
          errorsA = null;
        } else { errorsA = errors; }

        // Se calcula el resto, llamando a la función modulo97, definida más abajo
        const resto: string = modulo97(isbanaux);
        if (resto === '1') {
          returnV = errorsA;
        } else {
          returnV = { ibanValidator: true };
        }
      }
      return returnV;
    }
  };
};
